import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20a8 8 0 100-16 8 8 0 000 16zm-1-7V8h2v5h-2zm0 3v-2h2v2h-2z" }));
export default createSvgIcon(iconPath, "Alert");
//# sourceMappingURL=StatusAlertIcon.js.map